/*
 * Custom Hat Block add-on for hat-can products.
 * Renders under the color selection (see the custom_liquid block in
 * templates/product.can-builder.json). When the customer chooses "Yes", the
 * $39.95 Hat Can Block variant is added to the cart alongside the hat can,
 * and the required Perfect Fit Guide choice rides on the block as a line-item
 * property. When "No", the hat can is added the normal (Dawn) way.
 */
(function () {
  function init() {
    var root = document.querySelector('[data-can-block-addon]');
    if (!root || root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    var blockVariant = root.getAttribute('data-block-variant');
    var pfgWrap = root.querySelector('[data-pfg-wrap]');
    var pfg = root.querySelector('[data-pfg]');
    var radios = root.querySelectorAll('input[name="can_block_addon"]');

    function wantsBlock() {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked && radios[i].value === 'yes') return true;
      }
      return false;
    }
    function sync() {
      var yes = wantsBlock();
      if (pfgWrap) pfgWrap.hidden = !yes;
      if (!yes && pfg) { pfg.value = ''; pfg.style.borderColor = ''; }
    }
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', sync);
    sync();

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Capture-phase listener on document so it runs BEFORE Dawn's product-form
    // submit handler and can take over when a block is requested.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      // Only the product form that contains / precedes our add-on on this page.
      if (!document.querySelector('[data-can-block-addon]')) return;
      if (!wantsBlock()) return; // No block → let Dawn add the can normally.

      // Require a Perfect Fit Guide choice.
      if (pfg && !pfg.value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        pfg.style.borderColor = '#b00';
        pfg.focus();
        return;
      }

      // Take over: add the can + the block together.
      e.preventDefault();
      e.stopImmediatePropagation();

      var fd = new FormData(form);
      var canId = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      var canProps = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m) canProps[m[1]] = v;
      });

      var items = [
        { id: canId, quantity: qty, properties: canProps },
        {
          id: blockVariant,
          quantity: qty,
          properties: { 'Perfect Fit Guide': pfg ? pfg.value : '', '_addon_for': 'Hat Can' }
        }
      ];

      var btn = form.querySelector('[name="add"], [type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          window.location.href = cartRoot + 'cart';
        })
        .catch(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          alert('Sorry, something went wrong adding the Custom Hat Block. Please try again.');
        });
    }, true);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
